import { render, staticRenderFns } from "./PriceSquareRoot.vue?vue&type=template&id=6589dcc5&"
import script from "./PriceSquareRoot.vue?vue&type=script&lang=js&"
export * from "./PriceSquareRoot.vue?vue&type=script&lang=js&"
import style0 from "./PriceSquareRoot.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports